<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M14,3L2,3C0.9,3,0,3.9,0,5L0,12C0,13.1,0.9,14,2,14L14,14C15.1,14,16,13.1,16,12L16,5C16,3.9,15.1,3,14,3ZM2,12L2,5L14,5L14,12L2,12ZM6.59966,9.73C7.05966,9.93,7.75966,10.15,7.89966,10.48C8.02107,10.747119999999999,8.0049,10.9225,7.99963,10.97965C7.99839,10.9931,7.99775,11,7.99966,11L3.00966,11C3.00966,11,2.95966,10.809999999999999,3.09966,10.48C3.23966,10.15,3.93966,9.93,4.39966,9.73C4.80607,9.54446,4.81438,9.429179999999999,4.8246,9.287600000000001C4.82595,9.268930000000001,4.82733,9.2498,4.82966,9.23L4.82966,9.16C4.66966,9.02,4.52966,8.83,4.44966,8.6L4.44966,8.59C4.42966,8.54,4.40966,8.49,4.39966,8.440000000000001C4.28966,8.42,4.21966,8.3,4.19966,8.2C4.16966,8.15,4.11966,8.05,4.13966,7.93C4.14966,7.77,4.21966,7.7,4.28966,7.67L4.28966,7.64C4.28966,7.44,4.29966,7.15,4.34966,6.970000000000001C4.34966,6.91,4.35966,6.859999999999999,4.37966,6.8100000000000005C4.44966,6.58,4.58966,6.37,4.77966,6.23C4.96966,6.08,5.24966,6,5.49966,6C5.74966,6,6.02966,6.08,6.22966,6.23C6.41966,6.37,6.55966,6.58,6.62966,6.8100000000000005C6.63966,6.87,6.64966,6.92,6.65966,6.970000000000001C6.68966,7.16,6.70966,7.44,6.70966,7.64L6.70966,7.67C6.77966,7.69,6.83966,7.77,6.85966,7.93C6.86966,8.05,6.82966,8.16,6.79966,8.2C6.76966,8.3,6.70966,8.42,6.60966,8.43C6.58966,8.48,6.57966,8.530000000000001,6.55966,8.58C6.54966,8.59,6.54966,8.6,6.54966,8.6C6.46966,8.83,6.33966,9.02,6.17966,9.16L6.17966,9.23C6.18227,9.25225,6.18352,9.273810000000001,6.18474,9.29493C6.19286,9.435220000000001,6.19985,9.55617,6.59966,9.73ZM12,6L10,6C9.45,6,9,6.45,9,7C9,7.55,9.45,8,10,8L12,8C12.55,8,13,7.55,13,7C13,6.45,12.55,6,12,6ZM12,9L10,9C9.45,9,9,9.45,9,10C9,10.55,9.45,11,10,11L12,11C12.55,11,13,10.55,13,10C13,9.45,12.55,9,12,9Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'IdNumber',
} as DefineComponent
</script>
